module.exports = __webpack_public_path__ + "img/scene-piano.6484dc17.svg";